import React, { useState } from 'react';
import { Table, Form, InputGroup } from 'react-bootstrap';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useNFe, useAdicionarReferencia, useRemoverReferencia } from '../../../../hooks/useNFe';
import BotaoAdicionarReferenciaNFe from './BotaoAdicionarReferenciaNFe';

interface SecaoReferenciasProps {
  emissaoId: string;
  isReadOnly: boolean;
}

const SecaoReferencias: React.FC<SecaoReferenciasProps> = ({ emissaoId, isReadOnly }) => {
  const { data: nfe } = useNFe(emissaoId);
  const referencias = nfe?.referencias ?? [];
  const [novaChave, setNovaChave] = useState('');
  const [erro, setErro] = useState('');

  const adicionarMutation = useAdicionarReferencia(emissaoId);
  const removerMutation = useRemoverReferencia(emissaoId);

  const handleAdicionar = () => {
    if (!/^\d{44}$/.test(novaChave)) {
      setErro('Chave de acesso deve ter exatamente 44 dígitos numéricos');
      return;
    }
    setErro('');
    adicionarMutation.mutate(novaChave, {
      onSuccess: () => setNovaChave(''),
    });
  };

  return (
    <div>
      <p className="text-body-secondary small mb-3">
        Para NF-e de devolução, informe as chaves de acesso das notas originais.
      </p>

      {referencias.length > 0 && (
        <Table size="sm" bordered className="mb-3">
          <thead>
            <tr>
              <th>Chave de Acesso Referenciada</th>
              {!isReadOnly && <th style={{ width: 60 }}>Ação</th>}
            </tr>
          </thead>
          <tbody>
            {referencias.map((ref) => (
              <tr key={ref.id}>
                <td className="font-monospace small">{ref.chaveNFeReferenciada}</td>
                {!isReadOnly && (
                  <td>
                    <Button
                      variant="subtle-danger"
                      size="sm"
                      onClick={() => removerMutation.mutate(ref.id)}
                      loading={removerMutation.isPending}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {!isReadOnly && (
        <div className="d-flex flex-column gap-3">
          <BotaoAdicionarReferenciaNFe emissaoId={emissaoId} />

          <div>
            <p className="text-body-secondary small mb-1">Ou adicione uma chave manualmente:</p>
            <InputGroup>
              <Form.Control
                placeholder="Chave de acesso (44 dígitos)"
                value={novaChave}
                onChange={(e) => setNovaChave(e.target.value.replace(/\D/g, '').slice(0, 44))}
                maxLength={44}
                isInvalid={!!erro}
              />
              <Button
                variant="phoenix-primary"
                onClick={handleAdicionar}
                loading={adicionarMutation.isPending}
              >
                <FontAwesomeIcon icon={faPlus} className="me-1" /> Adicionar
              </Button>
            </InputGroup>
            {erro && <div className="text-danger small mt-1">{erro}</div>}
          </div>
        </div>
      )}
    </div>
  );
};

export default SecaoReferencias;
